'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _templateData = require('redux/modules/templateData');

var templateActions = _interopRequireWildcard(_templateData);

var _semanticUiReact = require('semantic-ui-react');

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Design = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    templates: state.company.design_templates,
    design_template_data: state.templateData.design_template_data,
    user_data: state.saveUserData.loaded_data,
    show_design_label: state.company.show_design_label,
    resume_name: state.templateData.resume_name,
    show_resume_name_modal: state.templateData.show_resume_name_modal,
    ReactGA: state.company.ReactGA,
    base_url: state.company.base_url,
    design_template_id: state.templateData.design_template_id,
    type_of_document: state.company.type_of_document,
    content_template_id: state.templateData.content_template_id,
    user_data_id: state.templateData.user_data_id
  };
}, (0, _extends3.default)({
  pushState: _reactRouterRedux.push,
  cleanDesignTemplate: _templateData.cleanDesignTemplate,
  cleanContentTemplate: _templateData.cleanContentTemplate
}, templateActions)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Design, _Component);

  function Design(props) {
    (0, _classCallCheck3.default)(this, Design);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Design.__proto__ || (0, _getPrototypeOf2.default)(Design)).call(this, props));

    _this.state = {
      templates: false
    };
    return _this;
  }

  (0, _createClass3.default)(Design, [{
    key: 'selectTemplate',
    value: function selectTemplate(template_id) {
      this.props.chooseTemplate(template_id);
      if (this.props.content_template_id || this.props.user_data_id) {
        this.props.pushState(this.props.base_url + '/design-view');
      } else {
        this.props.pushState(this.props.base_url + '/choose-content');
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {

      if (this.props.user_data) {}
      //this.props.pushState('/');

      // console.log(this.props.design_template_id);

      if (this.props.design_template_id && !this.props.params.design_template_id && !this.props.location.query.q) {
        this.props.pushState(this.props.base_url + '/choose-content');
      }

      if (!this.props.resume_name) {
        this.props.showResumeNameModal(true);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ templates: this.props.templates });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps) {
        this.setState({ templates: nextProps.templates });
      }
      if (!nextProps.show_resume_name_modal && !nextProps.resume_name) {
        this.props.showResumeNameModal(true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var templates = this.props.templates;
      var templates_copy = JSON.parse((0, _stringify2.default)(this.props.templates));
      var cardWidth = this.props.type_of_document == 'Personal Website' ? 400 : 210;
      var current;

      if (this.state.templates) {
        var segmentwrapper = (0, _keys2.default)(templates_copy).map(function (templateCategory) {
          current = templateCategory;
          return _react2.default.createElement(
            _semanticUiReact.Segment,
            { style: { background: 'rgba(245,245,245,.5)', marginTop: 10, marginBottom: 20 } },
            _react2.default.createElement(
              _semanticUiReact.Label,
              { as: 'a', color: 'black', ribbon: true },
              templateCategory
            ),
            _react2.default.createElement(
              _semanticUiReact.Card.Group,
              { style: { marginTop: 8, display: 'flex', justifyContent: 'center' }, itemsPerRow: 5 },
              templates[current].map(function (template) {
                return _react2.default.createElement(
                  _semanticUiReact.Card,
                  {
                    color: 'black',
                    key: template.id,
                    style: { width: cardWidth,
                      marginLeft: '2.5em',
                      marginRight: '2.5em',
                      marginBottom: '50px'
                    },
                    raised: true,
                    onClick: function onClick() {
                      _this2.props.chooseTemplate(false);
                      _this2.selectTemplate(template.id);
                      _this2.props.ReactGA.set({ dimension1: template.category + ' - ' + template.name });
                      _this2.props.ReactGA.event({
                        category: 'Resume - Choose Template',
                        action: template.category + ' - ' + template.name,
                        label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
                      });
                    } },
                  _this2.props.show_design_label && _react2.default.createElement(
                    _semanticUiReact.Label,
                    {
                      corner: true,
                      size: 'big',
                      color: template.free ? "teal" : "red" },
                    _react2.default.createElement(
                      'div',
                      {
                        style: { transform: 'rotate(45deg)',
                          textAlign: 'right',
                          fontSize: '9px',
                          paddingRight: template.free ? "7px" : "0px",
                          paddingBottom: template.free ? "1px" : "10px",
                          paddingTop: template.free ? "6px" : "10px" } },
                      template.free ? "FREE" : "PREMIUM"
                    )
                  ),
                  _react2.default.createElement(_semanticUiReact.Image, { src: template.image_url }),
                  _react2.default.createElement(
                    _semanticUiReact.Card.Content,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Card.Description,
                      { style: { textAlign: 'center' } },
                      template.name
                    )
                  )
                );
              })
            )
          );
        });

        // const {info, load} = this.props; // eslint-disable-line no-shadow
        var styles = require('./Design.scss');
        return _react2.default.createElement(
          'div',
          { style: { paddingLeft: 50, paddingTop: 50, paddingRight: 50 } },
          _react2.default.createElement(_components.UserProgress, { designScreen: true, homeScreen: false }),
          _react2.default.createElement(
            'h3',
            null,
            'Choose your design'
          ),
          _react2.default.createElement(
            _semanticUiReact.Segment,
            { style: { backgroundColor: 'rgba(245, 245, 245 , .5)' } },
            segmentwrapper
          )
        );
      } else {
        return _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            _semanticUiReact.Segment,
            { style: { minHeight: 400 } },
            _react2.default.createElement(
              _semanticUiReact.Dimmer,
              { active: true, inverted: true },
              _react2.default.createElement(_semanticUiReact.Loader, { inverted: true, content: 'Loading' })
            )
          )
        );
      }
    }
  }]);
  return Design;
}(_react.Component), _class2.propTypes = {
  //info: PropTypes.object,
  //load: PropTypes.func.isRequired
}, _temp)) || _class);
exports.default = Design;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Design/Design.js
// module id = 1759
// module chunks = 0